import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { COMMUNITIES_RESOURCE, CREATE_COMMUNITY_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const CreateCommunityService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_COMMUNITY_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.getCommunity(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: COMMUNITIES_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createCommunityFailed'),
            onSuccessMessage: t('createCommunitySuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateCommunityService;
